import { Box, Button, Step, StepContent, StepLabel, Stepper } from '@mui/material'
import { FC, useState } from 'react'
import { StepContents } from './ConnectInstagramAccount/Steps'

export const InnerStepper: FC<{ steps: StepContents }> = ({ steps }) => {
  const [activeStep, setActiveStep] = useState(0)
  const handleNext = () => setActiveStep((prevActiveStep) => prevActiveStep + 1)
  const handleBack = () => setActiveStep((prevActiveStep) => prevActiveStep - 1)

  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map(({ label, content }, i) => {
        return (
          <Step key={label}>
            <StepLabel
              sx={{ cursor: 'pointer' }}
              onClick={activeStep >= i ? () => setActiveStep(i) : undefined}
              role="button"
            >
              {label}
            </StepLabel>
            <StepContent>
              <Box>{content}</Box>

              <Box sx={{ mt: 7, display: 'flex', gap: 2 }}>
                <Button onClick={handleBack} size="small" variant="outlined" disabled={i === 0}>
                  戻る
                </Button>
                {steps.length !== i + 1 && (
                  <Button onClick={handleNext} size="small" variant="contained">
                    次へ
                  </Button>
                )}
              </Box>
            </StepContent>
          </Step>
        )
      })}
    </Stepper>
  )
}
